import React from 'react'
import { connect } from 'react-redux';
import Main from './main/Main'

import {} from '../../actions/report'

const Dashboard = ({}) => {
  return (<Main/>)
}

const mapStateToProps = () => ({});
  
  export default connect(mapStateToProps, { 
  })(Dashboard);